import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository, type DeleteDriverLocationParams } from '../infra/ShipmentRepository'

export type DeleteDriverLocationDependencies = {
  repository: ShipmentRepository
}

export function deleteDriverLocationFactory({ repository }: DeleteDriverLocationDependencies) {
  return async function deleteDriverLocationManually(params: DeleteDriverLocationParams) {
    try {
      return await repository.deleteDriverLocation(params)
    } catch (error) {
      throw new Error('Failed to delete location, please try again', { cause: error as Error })
    }
  }
}

export function deleteDriverLocation(params: DeleteDriverLocationParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const deleteDriverLocationManually = deleteDriverLocationFactory({ repository })

  return deleteDriverLocationManually(params)
}
